import type { SVGProps } from 'react';

const SvgFeaturedPlayList = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M23 3H1v18h22zm-11 8H3V9h9zm0-4H3V5h9z" />
  </svg>
);
export default SvgFeaturedPlayList;
